export default [
  {
    path: "/vendor",
    name: "vendor",
    component: () => import("@/views/vendor/layouts/Vendor.vue"),

    children: [
      {
        path: "product-vendor",
        name: "product-vendor",

        component: () =>
          import("@/views/vendor/pages/products/ProductVendor.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "vendor-order-management",
        name: "vendor-order-management",

        component: () =>
          import("@/views/vendor/pages/ordermanagement/OrderManagement.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-vendor",
        name: "add-vendor",

        component: () => import("@/views/vendor/pages/addvendor/AddVendor.vue"),
        children: [
          {
            path: "total-order-table",
            name: "total-order-table",
            component: () =>
              import(
                "@/views/vendor/pages/addvendor/components/TotalOrderTable.vue"
              ),
            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "pending-order-table",
            name: "pending-order-table",
            component: () =>
              import(
                "@/views/vendor/pages/addvendor/components/PendingOrderTable.vue"
              ),
            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "completed-order-table",
            name: "completed-order-table",
            component: () =>
              import(
                "@/views/vendor/pages/addvendor/components/CompletedOrderTable.vue"
              ),
            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "New-order-table",
            name: "New-order-table",
            component: () =>
              import(
                "@/views/vendor/pages/addvendor/components/NewOrderTable.vue"
              ),
            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
        ],
      },
    ],
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
];
